export default __webpack_public_path__ + "img/77ecf9c.svg";